import { render } from "./IconMerge.vue?vue&type=template&id=4034e9a5"
import script from "./IconMerge.vue?vue&type=script&lang=js"
export * from "./IconMerge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__